import React, { useState } from "react";
import VerifyCodePage from "./VerifyCodePage";


function RegisterPage({ initialEmail = "" }) {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState(initialEmail);
  const [phone, setPhone] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const [showVerify, setShowVerify] = useState(false);
  const [verifyEmail, setVerifyEmail] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!firstName.trim()) {
      setError("Please enter your first name.");
      return;
    }
    if (!lastName.trim()) {
      setError("Please enter your last name.");
      return;
    }
    if (!email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
      setError("Please enter a valid email address.");
      return;
    }
    if (!phone.match(/^\d{10}$/)) {
      setError("Please enter a valid 10-digit phone number.");
      return;
    }
    try {
      const response = await fetch("https://api.dev1.auth.joeandalese.com/v1/register", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        credentials: "include",
        body: JSON.stringify({
          firstName,
          lastName,
          email,
          phoneNumber: phone
        })
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        setError(data.error || data.message || "Registration failed. Please try again.");
        return;
      }
      setVerifyEmail(email);
      setShowVerify(true);
    } catch (err) {
      setError("Network error. Please try again.");
    }
  };

  if (showVerify && verifyEmail) {
    return <VerifyCodePage email={verifyEmail} />;
  }
  return (
    <div style={{ maxWidth: 400, margin: "80px auto", padding: 24, border: "1px solid #eee", borderRadius: 8, boxShadow: "0 2px 8px #f0f1f2" }}>
      <h2 style={{ textAlign: "center" }}>Register</h2>
      <form onSubmit={handleSubmit}>
        <label htmlFor="firstName">First Name</label>
        <input
          id="firstName"
          type="text"
          value={firstName}
          onChange={e => setFirstName(e.target.value)}
          style={{ width: "100%", padding: 8, margin: "8px 0 16px 0", borderRadius: 4, border: "1px solid #ccc" }}
          required
          autoFocus
        />
        <label htmlFor="lastName">Last Name</label>
        <input
          id="lastName"
          type="text"
          value={lastName}
          onChange={e => setLastName(e.target.value)}
          style={{ width: "100%", padding: 8, margin: "8px 0 16px 0", borderRadius: 4, border: "1px solid #ccc" }}
          required
        />
        <label htmlFor="email">Email Address</label>
        <input
          id="email"
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          style={{ width: "100%", padding: 8, margin: "8px 0 16px 0", borderRadius: 4, border: "1px solid #ccc" }}
          required
        />
        <label htmlFor="phone">Phone Number</label>
        <input
          id="phone"
          type="tel"
          value={phone}
          onChange={e => setPhone(e.target.value.replace(/\D/g, ""))}
          style={{ width: "100%", padding: 8, margin: "8px 0 16px 0", borderRadius: 4, border: "1px solid #ccc" }}
          required
          maxLength={10}
          placeholder="1234567890"
        />
        {error && <div style={{ color: "#d32f2f", marginBottom: 8 }}>{error}</div>}
        <button type="submit" style={{ width: "100%", padding: 10, background: "#1976d2", color: "#fff", border: "none", borderRadius: 4, fontWeight: 600 }}>
          Register
        </button>
      </form>
    </div>
  );
}

export default RegisterPage;
